var _Rect, _Path, _G, _G2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Rect, Path, G, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgDe = function SvgDe(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M0 6.667h28V0H0z",
    clipRule: "evenodd"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#F01515",
    fillRule: "evenodd",
    d: "M0 13.333h28V6.667H0z",
    clipRule: "evenodd"
  }))), _G2 || (_G2 = /*#__PURE__*/React.createElement(G, {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD521",
    fillRule: "evenodd",
    d: "M0 20h28v-6.667H0z",
    clipRule: "evenodd"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgDe;